import { isEqual } from 'lodash';
import { reaction, transaction } from 'mobx';

import { snackActions } from '../actions';

import { registrationAnalytics } from '../analytics';

import { disposers, isOfflineStore } from '../stores';

import { changeDistanceConditions } from '../selectors/changeDistanceConditions';
import { mainConditions } from '../selectors/mainConditions';

/**
 * @description
 * Observe conditions to display registration snacks that blocks registration
 */
function observeConditionsForPermanentSnacks() {
  const disposer = reaction(
    () => [
      mainConditions.isAlreadyRegisteredAndNotInvited.get(),
      mainConditions.isRegistrationOutdated.get(),
      mainConditions.isRegistrationClosed.get(),
      mainConditions.isDistanceSoldOut.get(),
      mainConditions.isInvalidInviteToken.get(),
      mainConditions.isRegistrationOutdatedForPushPayment.get(),
      changeDistanceConditions.errorCode.get(),
      changeDistanceConditions.isEmailMismatch.get(),
      isOfflineStore.value,
    ],
    () => {
      transaction(() => {
        if (mainConditions.isAlreadyRegisteredAndNotInvited.get()) {
          snackActions.blockedRegistration.alreadyRegisteredSnack.show();
          registrationAnalytics.blocked('already_registered');
        } else {
          snackActions.blockedRegistration.alreadyRegisteredSnack.clean();
        }

        if (
          (mainConditions.isRegistrationOutdated.get() && !mainConditions.isRegistrationClosed.get()) ||
          mainConditions.isRegistrationOutdatedForPushPayment.get()
        ) {
          snackActions.blockedRegistration.registrationOutdatedSnack.show();
          registrationAnalytics.blocked('outdated');
        } else {
          snackActions.blockedRegistration.registrationOutdatedSnack.clean();
        }

        if (mainConditions.isRegistrationClosed.get()) {
          snackActions.blockedRegistration.registrationClosedSnack.show();
          registrationAnalytics.blocked('closed');
        } else {
          snackActions.blockedRegistration.registrationClosedSnack.clean();
        }

        if (mainConditions.isDistanceSoldOut.get()) {
          snackActions.blockedRegistration.distanceSoldOutSnack.show();
          registrationAnalytics.blocked('sold_out');
        } else {
          snackActions.blockedRegistration.distanceSoldOutSnack.clean();
        }

        if (mainConditions.isInvalidInviteToken.get()) {
          snackActions.blockedRegistration.invalidInviteTokenSnack.show();
          registrationAnalytics.blocked('invalid_invite');
        } else {
          snackActions.blockedRegistration.invalidInviteTokenSnack.clean();
        }

        const changeDistanceErrorCode = changeDistanceConditions.errorCode.get();

        if (changeDistanceErrorCode) {
          snackActions.changeDistance.changeDistanceUnusableTokenSnack.show(changeDistanceErrorCode);
          registrationAnalytics.blocked('change_distance_unusable');
        } else {
          snackActions.changeDistance.changeDistanceUnusableTokenSnack.clean();
        }

        if (!changeDistanceErrorCode && changeDistanceConditions.isEmailMismatch.get()) {
          snackActions.changeDistance.changeDistanceEmailMismatchSnack.show(
            changeDistanceConditions.racerEmail.get() || '',
            changeDistanceConditions.signedInEmail.get() || '',
          );
        } else {
          snackActions.changeDistance.changeDistanceEmailMismatchSnack.clean();
        }

        if (isOfflineStore.value) {
          snackActions.offlineSnack.show();
          registrationAnalytics.blocked('offline');
        } else {
          snackActions.offlineSnack.clean();
        }
      });
    },
    { equals: isEqual, fireImmediately: true },
  );

  disposers.register(() => {
    disposer();
  });
}

export { observeConditionsForPermanentSnacks };
